// Smooth scroll for internal anchors (Shopify AJAX-compatible)
// Enhanced version with:
// - Event delegation (works for dynamically loaded links)
// - Hashchange listener (browser back/forward support)
// - Light debounce on header height recalculation

document.addEventListener('DOMContentLoaded', () => {
  // --- 1. Helper: get header height (debounced) ---
  let lastHeaderHeight = 0;
  let lastMeasuredAt = 0;
  const getHeaderHeight = () => {
    const now = Date.now();
    // Measure again only if >300ms since last check
    if (now - lastMeasuredAt > 300) {
      const header = document.querySelector('#shopify-section-header');
      lastHeaderHeight = header ? header.offsetHeight : 0;
      lastMeasuredAt = now;
    }
    return lastHeaderHeight;
  };

  // --- 2. Helper: perform smooth scroll with offset ---
  const smoothScrollTo = (hash) => {
    if (!hash) return;
    const target = document.querySelector(hash);
    if (!target) return;
    const offset = getHeaderHeight();
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  // --- 3. Handle clicks (using event delegation for dynamic menus) ---
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const url = new URL(link.href, window.location.origin);
    const current = window.location;
    const hasHash = url.hash && url.hash.length > 1;
    const samePage =
      url.origin === current.origin &&
      url.pathname.replace(/\/$/, '') === current.pathname.replace(/\/$/, '');

    // 1️⃣ Same-page anchor → prevent AJAX reload, scroll
    if (samePage && hasHash) {
      e.preventDefault();
      e.stopImmediatePropagation(); // block Shopify AJAX router
      history.pushState(null, '', url.hash);
      smoothScrollTo(url.hash);
      return;
    }

    // 2️⃣ Different page with anchor → remember target
    if (!samePage && hasHash) {
      sessionStorage.setItem('pendingAnchor', url.hash);
      // allow AJAX or full navigation
      return;
    }

    // 3️⃣ No hash or external link → default behavior
  }, true); // useCapture=true → run before Shopify AJAX handlers

  // --- 4. Handle direct hash on initial page load ---
  if (window.location.hash) {
    setTimeout(() => smoothScrollTo(window.location.hash), 200);
  }

  // --- 5. Handle Shopify AJAX navigation completion ---
  const runPendingAnchor = () => {
    const hash = sessionStorage.getItem('pendingAnchor');
    if (hash) {
      sessionStorage.removeItem('pendingAnchor');
      setTimeout(() => smoothScrollTo(hash), 300);
    }
  };

  // Listen to AJAX and section-load events
  document.addEventListener('shopify:page:load', runPendingAnchor);
  document.addEventListener('shopify:section:load', runPendingAnchor);
  document.addEventListener('page:load', runPendingAnchor); // fallback

  // --- 6. Support manual hash change (browser back/forward) ---
  window.addEventListener('hashchange', () => {
    smoothScrollTo(window.location.hash);
  });
});
